module.exports = __webpack_public_path__ + "img/CTO-Ihrom-Bayu.a479b3af.jpg";